<template>
  <div class="myfoot">
    <div class='top_lang'>
      <div :class="islang=='eng'?'bottom_':''" @click='cngo'>EN</div>|
      <div :class="islang=='big5'?'bottom_':''" @click='engo'>中文</div>
    </div>
    <div style="display: flex;justify-content: space-around;margin-top: .5rem;position: relative;"
      :style='{left: islang=="eng" ?"4rem":""}'  class='t1_class'>
      <!-- :class="i==0?'iszero':''" -->
      <div style=" margin-bottom: -.8rem;">
        <div v-for='(v,i) in t1' v-text="v.text" :key='i+"111"' class="colorgrey" @click='urlopen(v.url,v.text)'></div>
      </div>
      <div style=" margin-bottom: -.8rem;">
        <div v-for='(v,i) in t2' v-text="v.text" :key='i+"111"' class="colorgrey" @click='urlopen(v.url,v.text)'></div>
      </div>
      <div style=" margin-bottom: -.8rem;">
        <div v-for='(v,i) in t3' v-text="v.text" :key='i+"111"' class="colorgrey" @click='urlopen(v.url,v.text)'></div>
      </div>
      <div style="border-left: 1px solid #3e858b;padding-left: 2rem;">
        <div v-for='(val,i) in params.hotlineList' :key='i+"1515"'>
          <div class="iszero">{{val.text}}</div>
          <div class="isblue">{{val.phonenum}}</div>
        </div>
      </div>
    </div>
    <div v-for='(val,i) in params.hotlineList' :key='i+"1515"' class='t2_class'>
      <div class="iszero">{{val.text}}</div>
      <div class="isblue">{{val.phonenum}}</div>
    </div>
    <div style="width: 78%;font-size: 17px;"
      v-if='islang=="eng"'  class='bottom_cal'>
      {{params.menu_text1}}
      <div style="display: flex;justify-content: space-between;width: 42%;position: relative;left: 2rem;cursor: pointer;">
        <div style="display: flex;justify-content: space-between;width: 5rem;">
          <div :class="islang=='eng'?'bottom_':''" @click='cngo'>EN</div>|
          <div :class="islang=='big5'?'bottom_':''" @click='engo'>中文</div>
        </div>
        <div style="position: relative;left: 30%;">
          <!-- <a-popover v-model="visible" placement="bottom"  trigger="click"
          	 :overlayStyle="{width:'calc(9rem + 32px)'}">
            <template slot="content">
              <img :src="require('@/image/honggu/Wechat - QR CODE.jpg')" alt="" style="width: 9rem;margin: 0;">
              <center style="text-align: center;font-size: 16px;">{{$lang.qmiswx}}</center>
            </template> -->
            <img :src="require('@/image/home/wx1.png')" alt="" style="margin-right: 3rem;cursor:pointer"
             @click='visible=!visible'>
             <img :src="require('@/image/home/whatsapp.png')" alt="" style="margin-right: 3rem;cursor:pointer"
            @click='visible1=!visible1'>
          <!-- </a-popover> -->
          <img :src="require('@/image/home/sp.png')" alt="" @click='handisClick()'>
        </div>
      </div>
    </div>
    <!-- font-size: 16px; -->
    <div style="width: 82%;font-size: 17px;" v-else class='bottom_cal'>
      {{params.menu_text1}}
      <div style="display: flex;justify-content: space-between;width: 45.4%;">
        <div style="display: flex;justify-content: space-between;width: 5rem;cursor: pointer;">
          <div :class="islang=='eng'?'bottom_':''" @click='cngo'>EN</div>|
          <div :class="islang=='big5'?'bottom_':''" @click='engo'>中文</div>
        </div>
        <div style="position: relative;left: 15%;">
          <!-- <a-popover v-model="visible" placement="bottom"  trigger="click"
          	:overlayStyle="{width:'calc(9rem + 32px)'}">
            <template slot="content">
              <img :src="require('@/image/honggu/Wechat - QR CODE.jpg')" alt="" style="width: 9rem;margin: 0;">
              <center style="text-align: center;font-size: 16px;">{{$lang.qmiswx}}</center>
            </template> -->
            <img :src="require('@/image/home/wx1.png')" alt="" style="margin-right: 3rem;cursor:pointer"
            @click='visible=!visible'>

            <img :src="require('@/image/home/whatsapp.png')" alt="" style="margin-right: 3rem;cursor:pointer"
            @click='visible1=!visible1'>

          <!-- </a-popover> -->
          <img :src="require('@/image/home/sp.png')" alt="" @click='handisClick()'>
        </div>
      </div>
    </div>
    <div style="width: 100%;"  class='bottom_as'>
      {{params.menu_text1}}
      <div style="text-align: left;">
        <div>
            <img :src="require('@/image/home/wx1.png')" alt="" style="margin-right: 3rem;cursor:pointer"
            @click='visible=!visible'>
          <img :src="require('@/image/home/sp.png')" alt="" @click='handis=true'>
        </div>
      </div>
    </div>
    <div class="close_Cla" style='position: fixed;top: 0;left: 0;height: 100vh;width: 100vw;background-color: rgba(0,0,0,.45);
      display: flex;justify-content: center;align-items: center;z-index: 200;' @click='visible= false' v-if='visible'>
      <a-icon type="close" style='position: absolute;top: 2rem;right: 4rem;font-size: 1.5rem;color:#fff'/>
      <img :src="require('@/image/honggu/wx_en.png')" alt="" style='width: 16rem;' v-if="islang=='eng'">
      <img :src="require('@/image/honggu/wx_ch.png')" alt="" style='width: 16rem;' v-else>
    </div>
    <div class="close_Cla" style='position: fixed;top: 0;left: 0;height: 100vh;width: 100vw;background-color: rgba(0,0,0,.45);
      display: flex;justify-content: center;align-items: center;z-index: 200;' @click='visible1= false' v-if='visible1'>
      <a-icon type="close" style='position: absolute;top: 2rem;right: 4rem;font-size: 1.5rem;color:#fff'/>
      <img :src="require('@/image/honggu/WhatsApp_en.png')" alt="" style='width: 16rem;' v-if="islang=='eng'">
      <img :src="require('@/image/honggu/WhatsApp_ch.png')" alt="" style='width: 16rem;' v-else>
    </div>
    <handitem v-if='handis' @child='handis=false'></handitem>
  </div>
</template>
<script>
  import handitem from './handitemS.vue'
  export default {
    components:{handitem},
    data() {
      return {
        visible1:false,
        visible:false,
        handis:false,
        t1: [], //'香港股票','新股認購','環球股票','債券服務','資產管理','基金服務','委托帳戶','財務規劃'
        t2: [], //'開立帳戶','款項提存','股票轉倉','表格下載','服務收費','交易通告','常見問題','公眾假期'
        t3: [], //'關于我們','就業機會','聯系我們','隱私條例','風險披露','條款及細則','收集個人資料','安全提示及建議'
        params: {
          hotlineList: [],
        },
        islang: window.localStorage.guanwanglang,
      }
    },
    mounted() {
      this.getdate()
    },
    methods: {
      engo() {
        if (window.localStorage.guanwanglang = 'big5') {
          // window.localStorage.guanwanglang = ''
          window.localStorage.guanwanglang = 'big5'
          setTimeout(() => {
            // location.reload();
            location.href = location.href.split('?lang=')[0]
          }, 200)
        }
      },
      cngo() {
        if (window.localStorage.guanwanglang = 'eng') {
          // window.localStorage.guanwanglang = ''
          window.localStorage.guanwanglang = 'eng'
          setTimeout(() => {
            // location.reload();
            location.href = location.href.split('?lang=')[0]
          }, 200)
        }
      },
      postdata(){
        this.$ajax({
          method:'post',
          url:this.$api.yuyuekaihu
        }).then(res=>{
          if(res.data.qmiscode === 1000){
          }else{
            this.$message.warning(res.data.qmismsg)
          }
        })
      },
      jiaoxueshipin_en(){
        this.$ajax({
          method:'post',
          url:this.$api.jiaoxueshipin_en
        }).then(res=>{
          if(res.data.qmiscode === 1000){
          }else{
            this.$message.warning(res.data.qmismsg)
          }
        })
      },
      jiaoxueshipin_cn(){
        this.$ajax({
          method:'post',
          url:this.$api.jiaoxueshipin_cn
        }).then(res=>{
          if(res.data.qmiscode === 1000){
          }else{
            this.$message.warning(res.data.qmismsg)
          }
        })
      },
      handisClick(){
        this.handis=true
        console.log(this.islang);
        if (this.islang == 'big5') {
          this.jiaoxueshipin_cn()
        }else{
          this.jiaoxueshipin_en()
        }
      },
      urlopen(i,val) {
        console.log(val);
        if (val =='預約開戶' || val =='Make Appointment') {
          this.postdata()
          this.$router.push('/account_opening_appointment')
        }
        if(i.split('http').length>1){
            window.open(i)
          }else{
            this.$router.push(i)
            document.documentElement.scrollTop = 0;
          }
        // let a = ['/hksecurities_introduction', '/ipo_subscriptions', '/ussecurities_introduction', '/bonds_introduction', '/zichanguanli', '/fund_introduction', '/stockconnect_introduction', '/securities_transfer']
        // if (name == 't1' && a[i]) {
        //   this.$router.push(a[i])
        // }
        // let b = ['/assetmanage', 'https://hk.iqmis.com/accopen/main/Officialwebsite?lang=', '/deposit&withdrawal', '/download_form', '/services_fee', '/trading_announcement', '/FAQs',
        //   '/market_holiday'
        // ]
        // if (name == 't2' && b[i]) {
        //   if(b[i].split('http').length>1){
        //     window.open(b[i]+this.islang)
        //   }else{
        //     this.$router.push(b[i])
        //   }
        // }
        // let c = ['/about_us', '/join_us', '/contact_us',
        //   'http://www.qmisgroup.com/Files/Doc/PrivacyPolicy',
        //   'http://www.qmisgroup.com/Files/Doc/RiskDisclaimer',
        //   '/terms&conditions', '/hyperlinkpolicy', '/safenotice&advice'
        // ]
        // if (name == 't3' && c[i]) {
        //   if (i == 3 || i == 4) {
        //     let str = this.islang === 'eng' ? '-EN.pdf' : '.pdf'
        //     window.open(c[i] + str)
        //   } else {
        //     this.$router.push(c[i])
        //   }
        // }
      },
      getdate() {
        this.$ajax({
          method: 'post',
          url: this.$api.getGroupMenu,
        }).then(res => {
          this.t1 = []
          this.t2 = []
          this.t3 = []
          this.params = res.data
          res.data.groupMenuList.map((v, i) => {
            if (i < 8) {
              this.t1.push(v)
            } else if (16 <= i) {
              this.t3.push(v)
            } else {
              this.t2.push(v)
            }
          })
        })
      }
    }
  }
</script>

<style scoped>
  .close_Cla *, :after, :before{
    font-size: 25px !important;
  }
  .bottom_as{
    display: none;
    color: #fff;
    margin: 1.5rem auto;
    justify-content: space-between;
  }
  .bottom_cal{
    color: #fff;
    margin: 1.5rem auto;
    display: flex;
    justify-content: space-between;
  }
  .bottom_ {
    border-bottom: 3px solid #fff;
  }

  .myfoot {
    background-color: #09666e;
    width: 100%;
    padding: 1rem 17rem 1rem 5rem;

  }

  .colorgrey {
    cursor: pointer;
    color: #b5b5b5;
  }

  .colorgrey:hover {
    color: #fff;
  }

  .isblue {
    color: #a5d4ff;
  }

  .iszero {
    color: #fff;
  }

  .iszero,
  .colorgrey,
  .isblue {
    /* font-size: 16px; */
    font-size: 17px;
    margin-bottom: .8rem;
  }
  .t2_class{
    display: none;
  }
  .top_lang{
    display: none;
    justify-content: space-between;width: 5rem;
    color: #fff;
    margin-bottom: 1rem;
  }
  @media screen and (max-width:1100px){
    .top_lang{
      display: flex;
    }
    .t1_class{
      display:none !important;
    }
    .t2_class{
      display:block;
    }
    .myfoot{
      padding: 1rem;
    }
    .bottom_cal{
      display: none !important;
    }
    .bottom_as{
      display: flex;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/foot/foot_pc.vue